window.MNPQ_QUIZ_FLOW = {
  version: 2,
  productHandle: 'menopause-supplement-for-women-with-dong-quai-black-cohosh-prebiotics-probiotics',
  questionTotal: 11,
  lander: {
    header: {
      logo: 'mnpq_logo.svg',
      logoAlt: 'Nutraharmony'
    },
    blocks: [
      {
        type: 'carousel',
        name: 'product',
        navigation: 'thumbs',
        arrows: true,
        assets: [
          'mnpq_lander_product_main_figma_2x.png',
          'mnpq_lander_product_02_2x.jpg',
          'mnpq_lander_product_03_2x.jpg',
          'mnpq_lander_product_04_2x.jpg',
          'mnpq_lander_product_05_2x.jpg'
        ]
      },
      {
        type: 'intro',
        title: 'Nutraharmony Menopause Supplement was formulated to restore your whole hormonal system from the inside.',
        titleAccent: 'Nutraharmony Menopause Supplement',
        rating: '4.8',
        customers: '2,400+ Happy Customers',
        paragraphs: [
          'Most menopause supplements address one mechanism – usually hot flashes. Nutraharmony Menopause Supplement was built for the full cascade.',
          "It's the first supplement to combine a complete herbal botanical blend, three adaptogens, energy and vitality support, and a clinical prebiotic-probiotic stack – all in two daily capsules. The gut-hormone axis was left out of every other product in this category. Not here."
        ]
      },
      {
        type: 'formula',
        title: 'The most complete natural GLP-1 formula ever formulated.',
        intro: 'It delivers',
        ingredients: '25 synergistic ingredients:',
        items: [
          { asset: 'mnpq_formula_balance_2x.jpg', title: "Women's balance complex", text: 'Black Cohosh, Red Clover, Dong Quai, Wild Yam, Turmeric' },
          { asset: 'mnpq_formula_gut_2x.jpg', title: 'MAKTREK® probiotics + prebiotic blend', text: 'FOS, Artichoke, Chicory' },
          { asset: 'mnpq_formula_energy_2x.jpg', title: 'Energy & vitality', text: 'Ginseng, Maca, Ginkgo, DHEA, Flaxseed' },
          { asset: 'mnpq_formula_mood_sleep_2x.jpg', title: 'Mood & sleep blend', text: 'Ashwagandha, Chasteberry, Rhodiola' },
          { asset: 'mnpq_formula_gut_stack_2x.jpg', title: 'MAKTREK® probiotics + prebiotic blend', text: 'FOS, Artichoke, Chicory' }
        ],
        asset: 'mnpq_lander_formula_source_2x.png',
        cta: 'Shop Now'
      },
      {
        type: 'benefits',
        title: "Here's exactly how Nutraharmony Menopause Supplement works in your body",
        titleAccent: 'Nutraharmony Menopause Supplement',
        cta: 'Shop Now',
        items: [
          { number: '1', icon: 'mnpq_benefit_absorption_2x.png', title: 'Absorption', text: 'All 15 ingredients reach the small intestine intact — where GLP-1 secretion actually happens.' },
          { number: '2', icon: 'mnpq_benefit_hormonal_signalling_2x.png', title: 'Hormonal signalling restores', text: 'A delayed-release capsule carries every ingredient past stomach acid into the small intestine — where absorption peaks.' },
          { number: '3', icon: 'mnpq_benefit_hot_flashes_2x.png', title: 'Hot flashes and night sweats', text: 'Hot flash frequency drops and night sweats stop breaking sleep. Temperature regulation settles within two weeks.' },
          { number: '4', icon: 'mnpq_benefit_recovery_2x.png', title: 'Mood, gut, and energy recover', text: 'Ashwagandha and Rhodiola lower cortisol. MAKTREK probiotics support the gut-hormone axis. B6 and Ginkgo ease brain fog.' },
          { number: '5', icon: 'mnpq_benefit_sustain_2x.png', title: 'The system sustains itself', text: 'Vitamins D3 and E support bone density and cellular protection. All 25 ingredients keep working together.' }
        ]
      },
      {
        type: 'timeline',
        title: 'What to Expect From Nutraharmony Menopause Supplement',
        titleAccent: 'Nutraharmony Menopause Supplement',
        items: [
          { title: 'Days 1–3', text: 'Some women notice slight shifts after meals – the probiotics are beginning to change the gut environment. Sleep may feel slightly deeper. The system is starting to work.' },
          { title: 'Week 1–2', text: "Hot flash frequency starts to drop. Night sweats become less intense – you're waking up less, or not at all. People around you start noticing before you say a word." },
          { title: 'Week 3–4', text: "Energy levels stabilize through the afternoon. Brain fog lifts noticeably. You're back to doing things – concentrating at work, showing up in conversations – that the fatigue had been keeping you from." },
          { title: 'Week 5+', text: 'Mood is even. Hot flashes are rare or gone. Sleep is consistent and restoring. You feel strong in your body. Your hormonal system is working the way it was always meant to.' }
        ],
        cta: 'Shop Now'
      },
      { type: 'goal', cta: 'Shop Now' },
      {
        type: 'reviews',
        title: 'Real results from real people:',
        cta: 'Shop Now',
        items: [
          { asset: 'mnpq_lander_review_natalie_figma_2x.png', name: 'Natalie S.', quote: '“Great product. Works well and I feel so much better”' },
          { asset: 'mnpq_lander_review_johana_figma_2x.png', name: 'Johana L.', quote: '“It is easy to consume, it became my favorite brand of supplements”' },
          { asset: 'mnpq_lander_review_diane_figma_2x.png', name: 'Diane P.', quote: '“Fast shipping and the quality feels premium. I’ve been on it 3 weeks and already feeling calmer and sleeping so much better.”' },
          { asset: 'mnpq_lander_review_rebecca_figma_2x.png', name: 'Rebecca H.', quote: '“My sleep dramatically improved in the first few weeks. It truly delivers on sleep and mood — I feel like myself again.”' }
        ]
      },
      {
        type: 'offer',
        title: 'Claim Your 50% Discount Now',
        titleAccent: '50% Discount',
        text: 'or risk paying full price tomorrow',
        textAccent: 'full price tomorrow',
        urgency: "Take advantage of our one-time 50% OFF sale — it's ending soon!",
        urgencyAccent: '50% OFF',
        cta: 'Buy Now & Save',
        guarantee: '90-Day Money-Back Guarantee',
        asset: 'mnpq_lander_offer_source_2x.png',
        desktopAssets: {
          left: 'mnpq_lander_offer_left_figma_2x.png',
          right: 'mnpq_lander_offer_right_figma_2x.png'
        }
      },
      {
        type: 'footer',
        logo: 'mnpq_logo_white.svg',
        email: 'support@nutra-harmony.com',
        text: 'Quality results begin with quality ingredients.\nStart your wellness journey today.',
        rating: '4.8/5',
        buyers: '2,200+ Verified Buyers',
        links: [
          { label: 'Refund Policy', href: '/policies/refund-policy' },
          { label: 'Privacy Policy', href: '/policies/privacy-policy' },
          { label: 'Terms of service', href: '/policies/terms-of-service' },
          { label: 'Shipping Policy', href: '/policies/shipping-policy' },
          { label: 'Contact information', href: '/policies/contact-information' },
          { label: 'Cancellation Policy', href: '/policies/subscription-policy' }
        ],
        copyright: '© 2026, NUTRAHARMONY Official Website'
      }
    ]
  },
  steps: [
    { id: 'welcome', type: 'welcome' },
    { id: 'age', type: 'age', key: 'age', progress: 1, selection: 'single', advance: 'selection', title: 'What is your age range?', eyebrow: 'Tell more about you', options: ['30-39', '40-49', '50-59', '60-69', '70+'] },
    { id: 'proof', type: 'proof', progress: 1, eyebrow: 'You’re not alone' },
    {
      id: 'goal', type: 'question', key: 'goal', progress: 1, selection: 'multiple', advance: 'continue', title: 'What do you most want to get back?', options: [
        { text: 'Relief from hot flashes and night sweats', bold: ['Relief'] }, { text: 'Steady mood – less irritability and mood swings', bold: ['Steady mood'] }, { text: 'Clear thinking – no more brain fog', bold: ['Clear thinking'] }, { text: 'Real, restoring sleep', bold: ['restoring sleep'] }, { text: 'Consistent energy through the day', bold: ['Consistent energy'] }, { text: 'I just want to feel like myself again', bold: ['myself again'] }
      ]
    },
    {
      id: 'effects', type: 'question', key: 'effects', progress: 2, selection: 'multiple', advance: 'continue', title: 'Where are you noticing changes in your body?', options: [
        { text: 'My face, neck, and chest – flushing and sweating', bold: ['My face, neck, and chest'] }, { text: 'My belly – bloating and unexpected weight gain', bold: ['My belly'] }, { text: 'My joints and muscles – stiffness and soreness', bold: ['My joints and muscles'] }, { text: 'My skin and hair – dryness, thinning, or texture changes', bold: ['My skin and hair'] }, { text: "I haven't noticed physical signs yet", exclusive: true }
      ]
    },
    {
      id: 'duration', type: 'question', key: 'duration', progress: 3, selection: 'single', advance: 'selection', title: 'How long have you been experiencing these symptoms?', options: [
        { text: 'Just started – less than 6 months', bold: ['Just started'] }, { text: '6–12 months', bold: ['6–12 months'] }, { text: '1–2 years', bold: ['1–2 years'] }, { text: 'More than 3 years', bold: ['3 years'] }
      ]
    },
    {
      id: 'signs', type: 'question', key: 'signs', progress: 4, selection: 'multiple', advance: 'continue', title: "Have you noticed any of these changes – even if you haven't linked them to menopause?", options: [
        { text: 'Hair thinning or falling out more than usual', bold: ['Hair thinning or falling out'] }, { text: 'Skin drier, thinner, or losing elasticity', bold: ['drier, thinner', 'losing elasticity'] }, { text: 'Heart fluttering or occasional palpitations', bold: ['Heart fluttering', 'palpitations'] }, { text: 'Vaginal dryness or intimate discomfort', bold: ['Vaginal dryness', 'intimate discomfort'] }, { text: 'Joint stiffness – especially first thing in the morning', bold: ['Joint stiffness'] }, { text: 'None of these', exclusive: true }
      ]
    },
    {
      id: 'energy', type: 'question', key: 'energy', progress: 5, selection: 'single', advance: 'selection', title: 'How is your energy through the day?', options: [
        { text: 'Low – I struggle to get through the day', bold: ['Low'] }, { text: 'Moderate – I have energy but it fades fast', bold: ['Moderate'] }, { text: 'Good – I still have most of my energy', bold: ['Good'] }
      ]
    },
    {
      id: 'food-relationship', type: 'question', key: 'food_relationship', progress: 6, selection: 'single', advance: 'selection', title: 'How much sleep do you usually get?', options: [
        { text: 'More than 8 hours – but I still wake up tired', bold: ['More than 8 hours'] }, { text: '7–8 hours – fairly consistent', bold: ['7–8 hours'] }, { text: "Less than 6 hours – I can't sleep through the night", bold: ['Less than 6 hours'] }, { text: 'My sleep is completely unpredictable', bold: ['unpredictable'] }
      ]
    },
    {
      id: 'stress', type: 'question', key: 'stress', progress: 7, selection: 'single', advance: 'selection', title: 'How would you describe your mood lately?', options: [
        { text: "Flat and disconnected – I've lost interest in things I used to enjoy", bold: ['Flat and disconnected'] }, { text: 'Irritable and on edge – small things set me off', bold: ['Irritable and on edge'] }, { text: 'Mostly neutral – not great, not terrible', bold: ['Mostly neutral'] }, { text: 'Generally positive – just dealing with the physical symptoms', bold: ['Generally positive'] }
      ]
    },
    {
      id: 'hormone-education',
      type: 'education',
      progress: 8,
      title: "Your hormones don't drop in isolation. When estrogen shifts, it pulls everything with it.",
      titleAccent: 'When estrogen shifts, it pulls everything with it.',
      asset: 'mnpq_hormone_comparison_2x.png',
      alt: 'Hormonal balance compared with hormone disruption during menopause',
      paragraphs: [
        "Estrogen doesn't just regulate your cycle – it keeps your body temperature, sleep, mood, gut, and energy in check.",
        "During menopause it fluctuates rapidly, and your hypothalamus loses its calibration signal. That's what a hot flash is: your brain firing a false \"too hot\" alarm. The same shift disrupts cortisol, gut bacteria, and the neurotransmitters governing sleep and mood – all at once."
      ],
      symptomsTitle: 'One root cause. Many symptoms:',
      symptoms: [
        { icon: 'mnpq_solution_food_noise.svg', text: 'Food noise – the constant background pull toward eating' },
        { icon: 'mnpq_solution_sugar_cravings.svg', text: "Sugar and carb cravings that arrive even when you're not hungry" },
        { icon: 'mnpq_solution_energy_crash.svg', text: 'Intense sleepiness or brain fog after meals' },
        { icon: 'mnpq_solution_belly_fat.svg', text: "Belly fat that won't respond to diet or exercise" },
        { icon: 'mnpq_solution_blood_sugar.svg', text: 'Blood sugar spikes and afternoon crashes' }
      ],
      callout: 'That cascade needs support across every affected system before anything else can work.'
    },
    {
      id: 'impact', type: 'question', key: 'impact', progress: 8, selection: 'single', advance: 'selection', title: 'How much are these symptoms affecting your daily life?', options: [
        { text: "A lot – they're interfering with work, relationships, or sleep", bold: ['A lot'] }, { text: "Somewhat – it's noticeable but I'm managing", bold: ['Somewhat'] }, { text: "Mildly – I notice them but they don't hold me back", bold: ['Mildly'] }
      ]
    },
    {
      id: 'tried', type: 'question', key: 'tried', progress: 9, selection: 'multiple', advance: 'continue', title: 'What have you already tried for cravings or weight loss?', options: [
        { text: 'Generic menopause supplements (Black Cohosh, evening primrose, etc.)', bold: ['Generic menopause supplements'] }, { text: 'Hormone replacement therapy (HRT) or estrogen creams', bold: ['Hormone replacement therapy'] }, { text: 'Diet changes – low sugar, anti-inflammatory, Mediterranean', bold: ['Diet changes'] }, { text: 'More exercise or regular movement', bold: ['More exercise'] }, { text: 'Herbal teas and lifestyle remedies', bold: ['Herbal teas', 'lifestyle remedies'] }, { text: 'Nothing yet', exclusive: true }
      ]
    },
    {
      id: 'wrong-solutions',
      type: 'wrong-solutions',
      progress: 10,
      title: "Every solution you've tried worked around the problem. None reached the root cause.",
      titleAccent: 'None reached the root cause.',
      cards: [
        {
          title: 'Generic menopause supplements',
          text: 'Single-herb formulas target hot flashes only – they miss sleep, gut balance, cortisol, and energy entirely.',
          asset: 'mnpq_wrong_generic_supplements_2x.jpg',
          alt: 'Generic menopause supplements',
          imageSide: 'right',
          imageWidth: '42.5%',
          height: 148
        },
        {
          title: 'More exercise or movement',
          text: "Supports mood and circulation, but doesn't reach the gut-hormone axis or undo the hormonal cascade.",
          asset: 'mnpq_wrong_movement_2x.jpg',
          alt: 'Woman exercising',
          imageSide: 'left',
          imageWidth: '44.5%',
          height: 148
        },
        {
          title: 'Herbal teas and lifestyle remedies',
          text: "Too low a concentration of active compounds to shift what's happening hormonally.",
          asset: 'mnpq_wrong_herbal_remedies_2x.jpg',
          alt: 'Herbal remedies',
          imageSide: 'right',
          imageWidth: '44.5%',
          height: 130
        },
        {
          title: 'Diet changes',
          text: "Helpful for overall load, but diet can't replace the botanical compounds or restore a disrupted gut microbiome.",
          asset: 'mnpq_wrong_diet_changes_2x.jpg',
          alt: 'Diet changes',
          imageSide: 'left',
          imageWidth: '47%',
          height: 144
        },
        {
          title: 'Hormone replacement therapy (HRT) or estrogen creams',
          text: "HRT adds hormones externally but doesn't restore the systems estrogen was regulating. When women stop, unresolved symptoms return.",
          asset: 'mnpq_wrong_hrt_2x.jpg',
          alt: 'Hormone replacement therapy injection',
          imageSide: 'right',
          imageWidth: '35.5%',
          height: 188
        }
      ],
      conclusion: 'Until GLP-1 is supported at the gut level – with the full stack needed to stimulate, amplify, and sustain it – the craving cycle keeps running.'
    },
    {
      id: 'outcome', type: 'question', key: 'outcome', progress: 10, selection: 'multiple', advance: 'continue', title: 'When Nutraharmony Menopause Supplement starts working, what matters most to you?', titleAccent: 'Nutraharmony Menopause Supplement', options: [
        { text: "Getting a full night's sleep without waking up drenched", bold: ["full night's sleep"] }, { text: 'Getting through the day without brain fog or crashing energy', bold: ['brain fog', 'or crashing energy'] }, { text: 'Feeling emotionally even – not snapping at the people I love', bold: ['Feeling emotionally even'] }, { text: 'All of the above', selectAll: true }
      ]
    },
    {
      id: 'referral', type: 'question', key: 'referral', progress: 11, selection: 'single', advance: 'selection', title: 'Did you hear about Nutraharmony Menopause Supplement from a Doctor or Nutritionist?', titleAccent: 'Nutraharmony Menopause Supplement', helper: "Nutraharmony Menopause Supplement is commonly referenced in women's health and wellness communities around the world. Your feedback helps us understand how people are hearing about us.", helperAccent: 'Nutraharmony Menopause Supplement', options: [
        { text: 'Yes', bold: ['Yes'] }, { text: 'No', bold: ['No'] }
      ]
    },
    {
      id: 'black-cohosh',
      type: 'berberine-education',
      progress: 11,
      title: 'The root Native American healers used for women\'s change – long before "menopause" had a name',
      lead: "Cherokee and Algonquin women used Black Cohosh root for centuries to ease hormonal transitions – internal heat, mood shifts, physical restlessness. They didn't have a clinical name for it. They had a plant that worked.",
      leadBold: ['Black Cohosh root'],
      asset: 'mnpq_black_cohosh_content_2x.jpg',
      alt: 'Native American healer preparing roots and herbs',
      paragraphs: [
        {
          text: 'Modern research confirms it:'
        },
        {
          text: 'Black Cohosh reduces hot flash frequency by acting on the hypothalamus – the brain region that misfires during menopause. Almost no supplement pairs it with the full stack needed: adaptogens, probiotics, vitamins, and a complete botanical blend. Nutraharmony Menopause Supplement does.',
          runs: [
            { text: 'Black Cohosh reduces hot flash frequency by acting on the hypothalamus', className: '' },
            { text: 'Nutraharmony Menopause Supplement', className: 'mnpq__emphasis' }
          ]
        }
      ],
      callout: 'Most women notice the first shift within 1–2 weeks.'
    },
    { id: 'loading', type: 'loading', progress: 11, title: 'Building your hormonal health profile...', duration: 2000 },
    { id: 'results', type: 'results', progress: 11 },
    { id: 'lander', type: 'lander' }
  ]
};
